import { useState } from 'react';

interface PanelLoginProps {
  onLogin: () => void;
}

const PANEL_USERNAME = 'teknikservis';
const PANEL_PASSWORD = 'Ts@2024!Ankara';

const PanelLogin = ({ onLogin }: PanelLoginProps) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPass, setShowPass] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setTimeout(() => {
      if (username === PANEL_USERNAME && password === PANEL_PASSWORD) {
        sessionStorage.setItem('panel_auth', 'true');
        onLogin();
      } else {
        setError('Kullanıcı adı veya şifre hatalı.');
        setPassword('');
      }
      setLoading(false);
    }, 600);
  };

  return (
    <div className="min-h-screen bg-slate-950 flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        {/* Logo / Başlık */}
        <div className="text-center mb-8">
          <div className="w-16 h-16 flex items-center justify-center rounded-2xl bg-orange-500 mx-auto mb-4">
            <i className="ri-shield-keyhole-line text-white text-3xl"></i>
          </div>
          <h1 className="text-white text-2xl font-extrabold tracking-tight">Yönetim Paneli</h1>
          <p className="text-slate-400 text-sm mt-1">Devam etmek için giriş yapın</p>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="bg-slate-900 rounded-2xl p-6 border border-slate-800 space-y-4">
          <div>
            <label className="block text-xs font-medium text-slate-400 mb-1.5">Kullanıcı Adı</label>
            <div className="relative">
              <i className="ri-user-line absolute left-3 top-1/2 -translate-y-1/2 text-slate-500 text-sm"></i>
              <input
                type="text"
                value={username}
                onChange={e => { setUsername(e.target.value); setError(''); }}
                required
                autoFocus
                autoComplete="username"
                placeholder="Kullanıcı adınız"
                className="w-full bg-slate-800 border border-slate-700 rounded-lg pl-9 pr-4 py-3 text-sm text-white placeholder-slate-500 focus:outline-none focus:border-orange-500"
              />
            </div>
          </div>

          <div>
            <label className="block text-xs font-medium text-slate-400 mb-1.5">Şifre</label>
            <div className="relative">
              <i className="ri-lock-line absolute left-3 top-1/2 -translate-y-1/2 text-slate-500 text-sm"></i>
              <input
                type={showPass ? 'text' : 'password'}
                value={password}
                onChange={e => { setPassword(e.target.value); setError(''); }}
                required
                autoComplete="current-password"
                placeholder="••••••••••••"
                className="w-full bg-slate-800 border border-slate-700 rounded-lg pl-9 pr-10 py-3 text-sm text-white placeholder-slate-500 focus:outline-none focus:border-orange-500"
              />
              <button
                type="button"
                onClick={() => setShowPass(!showPass)}
                className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-200 cursor-pointer w-5 h-5 flex items-center justify-center"
              >
                <i className={showPass ? 'ri-eye-off-line' : 'ri-eye-line'}></i>
              </button>
            </div>
          </div>

          {error && (
            <p className="text-red-400 text-xs flex items-center gap-1 bg-red-500/10 border border-red-500/20 rounded-lg px-3 py-2">
              <i className="ri-error-warning-line"></i> {error}
            </p>
          )}

          <button
            type="submit"
            disabled={loading || !username || !password}
            className="w-full bg-orange-500 hover:bg-orange-600 disabled:opacity-50 disabled:cursor-not-allowed text-white py-3 rounded-lg font-semibold text-sm transition-all duration-200 cursor-pointer whitespace-nowrap flex items-center justify-center gap-2 mt-2"
          >
            {loading ? (
              <><i className="ri-loader-4-line animate-spin"></i> Giriş yapılıyor...</>
            ) : (
              <><i className="ri-login-box-line"></i> Giriş Yap</>
            )}
          </button>
        </form>

        <p className="text-center text-slate-600 text-xs mt-4">
          <i className="ri-lock-line mr-1"></i>
          Güvenli yönetim alanı
        </p>
      </div>
    </div>
  );
};

export default PanelLogin;
